import React from 'react'

import LazyImage from '@/components/LazyImage'


import { tw } from 'tagged-classnames-free';
export interface AvatarProps {
  url?: string | null
  className?: string
  name: string
  size?: number
}

const Avatar: React.FC<AvatarProps> = (props) => {
  const { url, name, className, size = 28 } = props
  return (
    <div
      className={tw`
        bg-f-bg-layout peer flex shrink-0 items-center justify-center rounded-full 
        font-semibold text-white hover:cursor-pointer ${className}
      `}
      style={{ width: size, height: size }}
    >
      {url ? (
        <LazyImage
          src={url}
          alt='user photo'
          width={size}
          height={size}
          fill={false}
          className='rounded-full'
        />
      ) : (
        name.charAt(0).toUpperCase()
      )}
    </div>
  )
}

export default Avatar
